export const GENERIC_ERROR = "Impossible d'enregistrer le changement. Réessayez.";

export const OFFLINE_MESSAGE = "Vous êtes hors connexion : rien n'a été enregistré. Réessayez quand la connexion est revenue.";

const BUSINESS_STATUSES = [400, 403, 404, 409];

// Shows only messages written for people: a plain-string `detail` of a 400/403/404/409, or the `message` of a
// structured 409. 422 validation lists, 5xx, network failures and unexpected shapes give the generic sentence —
// never an HTTP code, a trace or raw JSON.
export function errorMessage(error, fallback = GENERIC_ERROR) {
  if (error?.offline) return OFFLINE_MESSAGE;
  const status = error?.response?.status;
  if (!BUSINESS_STATUSES.includes(status)) return fallback;
  const detail = error.response.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (status === 409 && typeof detail?.message === "string" && detail.message.trim()) return detail.message;
  return fallback;
}

export function conflictInfo(error) {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status === 409 && detail && typeof detail === "object" && detail.code === "stage_changed") {
    return { code: "stage_changed", currentStatus: detail.current_status || null, message: detail.message };
  }
  return null;
}
